/**
 * Модуль для ежедневного бонуса
 */

import { logger } from "../../utils/logger.js";

/**
 * Создаёт debounce функцию
 */
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/**
 * Создаёт менеджер для ежедневного бонуса
 */
export function createDailyLoginManager({
  safeFetch,
  buildAuthHeaders,
  getApiUrl,
  getTelegramWebApp,
  getCurrentUser,
  setCurrentUser,
  updateUserBalancesUI,
  documentRef = document,
}) {
  let isClaiming = false;

  /**
   * Получает ежедневный бонус (с debounce)
   */
  const claimDailyDebounced = debounce(async function claimDailyInternal() {
    const currentUser = getCurrentUser();
    if (!currentUser) return;

    if (isClaiming) {
      logger.debug("⏳ Запрос уже выполняется, пропускаем...");
      return;
    }

    isClaiming = true;
    const telegramWebApp = getTelegramWebApp();
    const button = documentRef.querySelector('button[onclick*="claimDaily"]');
    const originalText = button ? button.textContent : "";

    if (button) {
      button.disabled = true;
      button.textContent = "⏳ Загрузка...";
    }

    try {
      const apiUrl = getApiUrl();
      const response = await safeFetch(`${apiUrl}/daily-login`, {
        method: "POST",
        headers: buildAuthHeaders(),
      });

      if (!response.success) {
        const errorCode = response.error || response.data?.error;
        if (errorCode === "already_claimed_today") {
          // Это нормальная ситуация, не ошибка
          if (telegramWebApp?.showAlert) {
            telegramWebApp.showAlert(
              "Вы уже получили ежедневный бонус сегодня. Вернитесь завтра!",
            );
          }
          return;
        }
        throw new Error(errorCode || "Ошибка получения бонуса");
      }

      const data = response.data;
      if (data.success) {
        // Обновляем данные пользователя
        const updatedUser = { ...currentUser, ...data.userData };
        setCurrentUser(updatedUser);
        updateUserBalancesUI(updatedUser);

        let message = data.message || "Ежедневный бонус получен! +10 монет 💰";
        if (data.professionBonus) {
          message += `\n\n✨ Бонус профессии Искажатель изображения: +${data.professionBonus.bonus} монет (${data.professionBonus.bonusPercent}%)`;
        }

        if (telegramWebApp?.showAlert) {
          telegramWebApp.showAlert(message);
        }
      } else if (data.error === "already_claimed_today") {
        if (telegramWebApp?.showAlert) {
          telegramWebApp.showAlert(
            "Вы уже получили ежедневный бонус сегодня. Вернитесь завтра!",
          );
        }
      }
    } catch (error) {
      // Пропускаем логирование для already_claimed_today
      if (error.message !== "already_claimed_today") {
        logger.error("Claim daily error:", error);
      }
      if (telegramWebApp?.showAlert) {
        telegramWebApp.showAlert(
          "Ошибка получения бонуса: " + (error.message || "Неизвестная ошибка"),
        );
      }
    } finally {
      isClaiming = false;
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  }, 1000);

  /**
   * Публичная функция для получения ежедневного бонуса
   */
  function claimDaily() {
    claimDailyDebounced();
  }

  return {
    claimDaily,
  };
}













